<div class="card">
    <app-scorecard-row *ngFor="let row of rows()" class="row" [class]="row.classes" [row]="row"></app-scorecard-row>
</div>
